import { useSelector } from "react-redux"

export const useDiariesSelector = () => useSelector((state) => {
    return state.clientDiary.diaries
})

// ------------------- selector error messages ------------------ //
export const useDiaryCreateErrorMessageSelector = () => useSelector((state) => {
    return state.clientDiary.errorMessages.createDiaryErrorMessage
})

export const useDiaryDeleteErrorMessageSelector = () => useSelector((state) => {
    return state.clientDiary.errorMessages.deleteDiaryErrorMessage
})

export const useDiaryUpdateErrorMessageSelector = () => useSelector((state) => {
    return state.clientDiary.errorMessages.updateDiaryErrorMessage
})

export const useDiariesGetErrorMessageSelector = () => useSelector((state) => {
    return state.clientDiary.errorMessages.getDiariesErrorMessage
})

export const useDiaryGetErrorMessageSelector = () => useSelector((state) => {
    return state.clientDiary.errorMessages.getDiaryErrorMessage
})

// ------------ status selectors ------------ //
export const useDiaryCreateStatusSelector = () => useSelector((state) => {
    return state.clientDiary.statuses.createDiaryStatus
})

export const useDiaryDeleteStatusSelector = () => useSelector((state) => {
    return state.clientDiary.statuses.deleteDiaryStatus
})

export const useDiaryUpdateStatusSelector = () => useSelector((state) => {
    return state.clientDiary.statuses.updateDiaryStatus
})

export const useDiariesGetStatusSelector = () => useSelector((state) => {
    return state.clientDiary.statuses.getDiariesStatus
})

export const useDiaryGetStatusSelector = () => useSelector((state) => {
    return state.clientDiary.statuses.getDiaryStatus
})

export const useMoreDirayItemsLeftInPaginationSelector = () => useSelector((state) => {
    return state.clientDiary.moreDiaryItemsLeftInPagination
})